import { Inject, Injectable } from "@angular/core";
import { AppDataService } from "@app/services/appData.service";

@Injectable({ providedIn: "root" })
export class FeatureFlagService {
    constructor(@Inject(AppDataService) private appService: AppDataService) {}

    isAsyncFeatureEnabled(): boolean {
        return this.appService.appSettings.asyncFeatureEnabled;
    }
}
